export default __webpack_public_path__ + "images/f2e6ec9ad11ee03165461fe944a9481a-return.svg";